import { reactIcons } from "./icons";
import {
  Report,
  Login,
  AffiliateList,
  Franchise,
  Payout
} from "../pages/pageListAsync";
import Commission from "../pages/Commission";

export const sideBarLinks = [
  {
    path: "/login",
    title: "Click here to Login",
    icon: reactIcons.login,
    key: true,
    component: <Login />
  }
];
export const dashboardSideBar = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: reactIcons.dashboard,
    key: false,
    component: <Report />
  },

  {
    path: "/affiliate",
    title: "Affiliate",
    icon: reactIcons.affiliate,
    key: false,
    component: (
      // <PrivateRouteForAffilate>
      <AffiliateList />
      // </PrivateRouteForAffilate>
    )
  },
  {
    path: "/franchise",
    title: "Franchise",
    icon: reactIcons.franchise,
    key: "",
    component: (
      // <PrivateRouteFranchise>
      <Franchise />
      // </PrivateRouteFranchise>
    )
  },
  {
    path: "/payout",
    title: "Payout",
    icon: reactIcons.bank,
    key: "",
    component: (
      // <PrivateRouteFranchise>
      <Payout />
      // </PrivateRouteFranchise>
    )
  },
  {
    path: "/commission",
    title: "Commission",
    icon: reactIcons.fraction,
    key: "",
    component: <Commission />
  }
];

export const formatTime = (milliseconds) => {
  const seconds = Math.floor((milliseconds / 1000) % 60);
  const minutes = Math.floor(milliseconds / 1000 / 60);
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`; // Format as MM:SS
};
